import { Button } from '@any-ui-react/core';
import { useFormContext, useWatch } from 'react-hook-form';

import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { useEmployeeAccess } from '@/common/hooks/employees/useEmployeeAccess';
import type { EmergencyContactType, EmployeePersonalInformationFormDataType } from '@/common/types';

import { EmergencyContactModal } from './EmergencyContactModal';
import { EmergencyContactTable } from './EmergencyContactTable';

interface EmergencyContactsProps {
  onCreate: (data: EmergencyContactType) => void;
  onUpdate: (data: EmergencyContactType) => void;
  onRemove: (id: string) => void;
}

export const EmergencyContacts = ({ onCreate, onUpdate, onRemove }: EmergencyContactsProps) => {
  const {
    formState: { errors },
    control,
  } = useFormContext<EmployeePersonalInformationFormDataType>();
  const emergencyContacts = useWatch({ control, name: 'emergencyContacts' });

  const { employeeDetail } = useEmployeeDetailContext();
  const isNewRecord = !employeeDetail.id;
  const { hasEmployeePersonalInformationEditAccess } = useEmployeeAccess();
  const isEditable = hasEmployeePersonalInformationEditAccess || isNewRecord;

  return (
    <div className="mb-6">
      <div className="mb-4 flex gap-2 items-center justify-between">
        <h1 className="font-semibold">Emergency Contacts</h1>
        {isEditable && (
          <EmergencyContactModal isNewRecord={true} onSuccess={onCreate}>
            <Button variant="default">Add New Contact</Button>
          </EmergencyContactModal>
        )}
      </div>
      <EmergencyContactTable
        isEditable={isEditable}
        items={emergencyContacts}
        loading={false}
        onRemove={onRemove}
        onUpdate={onUpdate}
      />
      {errors.emergencyContacts && <span className="text-xs text-red-6">{errors.emergencyContacts.message}</span>}
    </div>
  );
};
